<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<ul class="nav flex-column">

					<li class="nav-item">
    					<button class="btn nav-link active py-2" data-bs-toggle="tab" data-bs-target="#general"><i class="fa fa-lg mb-2 fa-building"></i><br />Alapadatok</button>
  					</li>
					<li class="nav-item">
    					<button class="btn nav-link py-2" data-bs-toggle="tab" data-bs-target="#contact"><i class="fa fa-lg mb-2 fa-phone"></i><br />Kapcsolat</button>
  					</li>
				</ul>

			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<h2><%= company.name %></h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Partnerek</li>
							<li class="breadcrumb-item"><a href="/company/list">Cégek</a></li>
							<li class="breadcrumb-item active"><%= company.name %></li>
						</ol>
					</div>

					<div class="grid-wrapper card bg-dark p-3">
						<div class="tab-content" id="company_edit_tabs">
							<div class="tab-pane show active" id="general">
								<%- include('/ui/form', {
									params: [ 'company', company ],
									fields: [
										{ type: 'row', fields: [
											{ type: 'col', fields: [
												{ type: 'hidden', name: 'id' },
												{ type: 'fieldset', title: 'Alapadatok', fields: [
													{
														type: 'text',
														name: 'name',
														title: 'Név'
													},
													{
														type: 'text',
														name: 'tax_number',
														title: 'Adószám'
													},
													{
														type: 'select',
														name: 'group_id',
														title: 'Cégcsoport',
														params: {
															maxItems: 1,
															options: company_groups.data,
															valueField: 'id',
															labelField: 'name',
															searchField: 'name'
														},
														unset_value: null
													},
												]},
												{ type: 'fieldset', title: 'Számlázás', fields: [
													{
														type: 'select',
														name: 'invoicing_period',
														title: 'Számlázási periódus',
														params: {
															maxItems: 1,
															options: [
																{ value: 'monthly', label: 'Havi' },
																{ value: 'quarterly', label: 'Negyedéves' },
																{ value: 'half-yearly', label: 'Féléves' },
																{ value: 'annual', label: 'Éves' }
															],
															valueField: 'value',
															labelField: 'label'
														},
														unset_value: null
													},
													{
														type: 'group',
														title: 'Számlázási cím (székhely)',
														fields: [
															{
																type: 'text',
																name: 'invoice_area_code',
																attributes: {
																	placeholder: 'Irsz.'
																},
																width: 2
															},
															{
																type: 'text',
																name: 'invoice_city',
																attributes: {
																	placeholder: 'Város'
																},
																width: 3
															},
															{
																type: 'text',
																name: 'invoice_address',
																attributes: {
																	placeholder: 'Utca, házszám'
																}
															}
														]
													}
												]}
											]},
											{ type: 'col', fields: [] }
										]}
									]
								}) %>
							</div>
							<div class="tab-pane" id="contact">

							</div>
						</div>
					</div>

				</div>
			</div>

			<div class="py-3">
				<a href="/company/list" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</a>
				<div class="float-end">
					<button class="btn btn-success" onclick="Anvil.page.save()"><i class="fa fa-save me-3"></i>Mentés</button>
					<button class="btn btn-danger ms-2 disabled" onclick="Anvil.page.delete()"><i class="fa fa-trash me-3"></i>Törlés</button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	async save () {
		const res = await Anvil.exec('company/action_save', Anvil.page.company)
	}
})
</script>
